import React, { useState,useCallback } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./Login.css";
import "./App.css";

import Card from "react-bootstrap/Card";
import { useNavigate } from "react-router-dom";
import { post } from "./Api";

import axios from "axios";
import Particles from "react-particles";
import { loadFull } from "tsparticles";
import Loading from "./Loading";
import { Container, Row, Col, CardImg } from "reactstrap";
import BrandLogo from "./logo.png";
import { Link } from "react-router-dom";

export default function Login({ setUser }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [accountId, setAccountId] = useState("");
  const [environment, setEnvironment] = useState("uat");
  const [isLoading, setLoading] = useState(false);

  

  const particlesInit = useCallback(async engine => {
    console.log(engine);
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(engine);
}, []);

const particlesLoaded = useCallback(async container => {
    await console.log(container);
}, []);


  let navigate = useNavigate();

  function validateForm() {
    return email.length > 0 && password.length > 0 && accountId.length > 2;
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  async function handleOnlogin(event) {
    event.preventDefault();
    const r = await onLogin();
    if (r) {
      let user = JSON.stringify({ accountId: accountId, loginId: email,environment:environment });
      setLoading(true);
      localStorage.setItem("userInfo", user);
      setUser(user)
      setTimeout(() => {
        navigate("/home");
      }, 3000);
    } else {
      alert("Username or password incorrect");
    }
  }

  function readURL(env) {
    switch (env) {
      case "uev":
        return "https://dev.sellina.io";
      case "uat":
        return "https://uat.sellina.io";
      case "demo":
        return "https://api.sellinademo.io";
      case "prod":
        return "https://prod.sellina.io";
      case "prod-egtm":
          return "https://prod-egtm.sellina.io";
      case "prod-us-west":
          return "https://prod-us-west.salescode.ai"
      case "prod-eu-south":
          return "https://prod-eu-south.salescode.ai"
      default:
        return "https://dev.sellina.io";
    }

  }
  async function onLogin() {
    return new Promise((res, rej) => {
      let loginData = {
        loginId: email,
        password: password,
        lob: accountId,
        environment:environment
      }
      const authService = window.cmb.getService('Auth')
      const currentDomain = window.location.hostname;

      var url2use ="https://sulfar.sellina.io/api";
      if (currentDomain.includes("salescode.ai")) {
        url2use="https://sulfur.salescode.ai/api";
      } 
      authService.setBaseUrl(url2use) //readURL(environment)
      authService.signIn(loginData).then(response => {
        if (response.status === 200) {
          axios.get(url2use+"/authorize?environment="+environment, {
            headers: {
              Authorization: '' + response.data.token //the token is a variable which holds the token
            }
          }).then(response1 => {
              res(response.data)
          }).catch(error => {
              console.log(error);
          })
        } else {
          alert("Failed to Login : Invalid Login details");
          res(null);
        }
      }).catch(er => {
        alert("Failed to Login : Invalid Login details");
        res(null);
      });
    })
  }

  async function onLocalLogin() {
    let loginData = {
      username: email,
      password,
      environment: environment
    }
    loginData.lob = accountId;
    const resp = await post("/login", loginData);
    if (!resp) {
      return null;
    } else {
      return resp;
    }


  }

  return (
    <>
      {isLoading &&  <Loading text="Loading something special..." />}
      <Particles 
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
                background: {
                    color: {
                        value: "#123",
                    },
                    
                },
                fpsLimit: 30,
                interactivity: {
                    events: {
                        onClick: {
                            enable: true,
                            mode: "push",
                        },
                        onHover: {
                            enable: true,
                            mode: "repulse",
                        },
                        resize: true,
                    },
                    modes: {
                        push: {
                            quantity: 1,
                        },
                        repulse: {
                            distance: 200,
                            duration: 0.4,
                        },
                    },
                },
                particles: {
                    color: {
                        value: "#ffffff",
                    },
                    links: {
                        color: "#ffffff",
                        distance: 150,
                        enable: true,
                        opacity: 0.5,
                        width: 1,
                    },
                    collisions: {
                        enable: true,
                    },
                    move: {
                        directions: "none",
                        enable: true,
                        outModes: {
                            default: "bounce",
                        },
                        random: false,
                        speed: 2,
                        straight: false,
                    },
                    number: {
                        density: {
                            enable: true,
                            area: 800,
                        },
                        value: 80,
                    },
                    opacity: {
                        value: 0.5,
                    },
                    shape: {
                        type: "circle",
                    },
                    size: {
                        value: { min: 1, max: 5 },
                    },
                },
                detectRetina: true,
            }}
        />
      {!isLoading && <div className="Login" style={{ marginTop: "0px", display: "flex",justifyContent:"right" }}>

      <Container style={{ width: "500px",maxWidth:"500px", height: "500px",margin:"auto" }}>
              <Row
                className="d-flex justify-content-between align-items-center"
                style={{ width: "100%", minHeight: "100%" }}
              >
                <Col
                  className="animated bounceInDown title__info"
                  sm="12"
                  md="8"
                >
                  <h1 style={{ color: "yellow" }}>SULFAR</h1>
                  
                  <h6 style={{ color: "#fff", letterSpacing: "3px" }}>
                    Sales Uplift with Forcast and Recommendations {" "}
                  </h6>
                 
                </Col>
                <Col className="brandlogo" sm="12" md="4">
                  <CardImg
                    className="animated flipInY delay-1s brandlogo__img"
                    src={BrandLogo}
                    alt="logo"
                  />
                </Col>
              </Row>
            </Container>
        <Card style={{ margin: "10px",background:"#3fe0fd99",boxShadow:"unset",border:"1px solid #000" }}>
          <Card.Body>
            <Card.Title size="lg" style={{ color: "#fff", textAlign: "center",padding:"10px",background:"#000" }}>Login</Card.Title>
            <Card.Subtitle className="mb-2 text-muted">
            </Card.Subtitle>
            <Card.Text>

            </Card.Text>
            <Form onSubmit={handleSubmit}>




              <Form.Group size="lg" controlId="env">
                <Form.Label>Environment</Form.Label>
                <Form.Select aria-label="Default select example"
                value={environment}
                onChange={(e) => {
                  console.log(e.target.value)
                  setEnvironment(e.target.value)
                }}
                >
                  <option value="uat">UAT</option>
                  <option value="dev">DEV</option>
                  <option value="prod">PROD</option>
                  <option value="prod-egtm">PROD-EGTM</option>
                  <option value="demo">DEMO</option>
                  <option value="prod-us-west">PROD-US-WEST</option>
                  <option value="prod-eu-south">PROD-EU-SOUTH</option>
              
                </Form.Select>
              </Form.Group>

              <Form.Group size="lg" controlId="email">
                <Form.Label>Username/Email</Form.Label>
                <Form.Control
                  autoFocus
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
              <Form.Group size="lg" controlId="lob">
                <Form.Label>Account/Lob</Form.Label>
                <Form.Control
                  type="text"
                  value={accountId}
                  onChange={(e) => setAccountId(e.target.value)}
                />
              </Form.Group>
              <Form.Group size="lg" controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>


              <br></br>
              <Button style={{ width: "100%" }} block size="lg" type="button" disabled={!validateForm()} onClick={e => handleOnlogin(e)}>
                Login
          </Button>
          <div style={{height:"50px"}}></div>
            </Form>
          </Card.Body>
        </Card>
      </div>

       }

    </>
  );
}
